import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Card, CardContent } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import { getImg } from 'src/services/AssetApi';
import SubmitButton, { useCustomFormik } from 'src/components/formik-helper';
import QuillEditor from 'src/components/quill-editor';
import DateAndTimePicker from 'src/components/widgets/date-time-picker';
import ReadOnlyTextField from 'src/components/widgets/readonly-textfield';
import NumberTextField from 'src/components/widgets/number-textfield';
import { initialValues, validationSchema, handleSubmitted } from './formik';
import { MobileDateTimePicker } from '@mui/x-date-pickers/MobileDateTimePicker';
import ZoomImages from 'src/components/zoom-images';
import StringTextField from 'src/components/widgets/string-textfield';

export const DetailForm = (props) => {
  const { item, apiUpdate, apiSendTicket, apiUnsendTicket, ...other } = props;
  const [submitState, setSubmitState] = useState({ verified: false });
  
  const formik = useCustomFormik({
    initialValues: { smsField: null },
    validationSchema: validationSchema(),

    onSubmit: async (values) => {
      await handleSubmitted(values, item, apiUpdate, apiSendTicket, apiUnsendTicket);
    },
  });

  useEffect(() => {
    initialValues(formik, item);
    
    if (item) {
      setSubmitState(prev => ({ 
        ...prev,
        reason: item.ticket?.reason,
        verified: !!item.ticket
      }));

      // Map through item.assets array and update the name for each object
      const updatedAssets =
        item.evidences?.map((img) => ({
          ...img,
          name: getImg(img.name),
          selected: img.thumb,
          readonly: true,
          disabled: !img.thumb,
        })) || [];
      // Set formik field with the updated assets array
      formik?.setFieldValue('defaultImgs', updatedAssets);
    }
  }, []);

  const handleVerify = (isChecked) => {
    let reason = item?.ticket?.reason;
    if(reason){
      reason = isChecked ? reason : 'Hủy thông báo';
    }
    setSubmitState(prev => ({ 
      ...prev,
      reason: reason,
      verified: isChecked
    }));
  };

  return (
    <Card>
      <CardContent sx={{ px: 1, py: 2 }}>
        <Grid container spacing={3}>
          <Grid xs={12} md={6}>
          <form onSubmit={formik.handleSubmit} {...other}>
            <Grid container spacing={3}>
              <Grid xs={12} md={6}>
                <ReadOnlyTextField label="Ngày nhận xe" value={item.checkinSys} />
              </Grid>

              <Grid xs={12} md={6}>
                <ReadOnlyTextField label="Ngày trả xe" value={item.checkoutSys} />
              </Grid>

              <Grid xs={12} md={6}>
                <ReadOnlyTextField label="Người nhận" value={item.contact?.name} />
              </Grid>

              <Grid xs={12} md={6}>
                <ReadOnlyTextField label="Số điện thoại" value={item.contact?.phone} enumType='phone' />
              </Grid>

              <Grid xs={12} md={6}>
                <ReadOnlyTextField label="Biển số" value={item.car?.name} />
              </Grid>

              <Grid xs={12} md={6}>
                <ReadOnlyTextField label="Trips (km)" value={item.trips} />
              </Grid>
              
              <Grid xs={12} md={6}>
                <NumberTextField
                  label="Km lúc nhận"
                  name="checkinKm"
                  formik={formik}
                  inputProps={{ maxLength: 7 }}
                  hintValue={item.checkinKm}
                />
              </Grid>

              <Grid xs={12} md={6}>
                <NumberTextField
                  label="Km lúc trả"
                  name="checkoutKm"
                  formik={formik}
                  inputProps={{ maxLength: 7 }}
                  hintValue={item.checkoutKm}
                />
              </Grid>
              
              <Grid xs={12} md={6}>
                <DateAndTimePicker
                  label="Giờ xe ra"
                  name="checkinBy"
                  format="dd/MM/yyyy - HH:mm"
                  formik={formik}
                  hintValue={item.checkinHint}
                >
                  <MobileDateTimePicker ampm={false} />
                </DateAndTimePicker>
              </Grid>

              <Grid xs={12} md={6}>
                <DateAndTimePicker
                  label="Giờ xe về"
                  name="checkoutBy"
                  format="dd/MM/yyyy - HH:mm"
                  formik={formik}
                  hintValue={item.checkoutHint}
                >
                  <MobileDateTimePicker ampm={false} />
                </DateAndTimePicker>
              </Grid>

              <Grid xs={12} md={12}>
                <StringTextField
                  label="Nội dung"
                  name="smsField"
                  formik={formik}
                  hintValue={submitState.reason}
                />
              </Grid>

              {/* Web Browser & Mobile */}
              <Grid xs={12}
                  sx={{
                    display: { xs: 'center', md: 'flex' },
                    justifyContent: { xs: 'center', md: 'flex-end' }
                  }}>
                <SubmitButton formik={formik} isRemove={true} labelRemove={'Gửi thông báo'} 
                  hasVerified={submitState.verified} onVerifyChange={handleVerify} />
              </Grid>
              
            </Grid>
            </form>
          </Grid>
          <Grid xs={12} md={6}>
            <><Grid container spacing={3}>
                <Grid xs={12}>
                  <QuillEditor
                    value={item.note}
                    isReadOnly={true}
                    sx={{height: 75}}
                  />
                </Grid>

                <Grid
                  container
                  spacing={2}
                  sx={{
                    textAlign: 'center',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  {item.evidences?.map((img, index) => (
                    <Grid item="true" key={index} spacing={3} xs={4}>
                      <ZoomImages
                        item={img}
                        imgArray={item.evidences}
                        alt={img.id}
                        checked={!!img.location}
                        height="96"
                        frame="165px"
                      />
                    </Grid>
                  ))}
                </Grid>
              </Grid>
            </>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

DetailForm.propTypes = {
  item: PropTypes.object.isRequired,
  apiUpdate: PropTypes.func,
  apiRemove: PropTypes.func,
  toastError: PropTypes.func,
};